import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IAdministrativeComplaintView, IBusinessCitationView } from 'app/models/mainMenu/mainMenu';
import { IComplaintSearchViewModel } from 'app/models/search/search';
import { IReportSelectItems } from 'app/models/shared/shared';
import { IEnclosedAreaReportView } from 'app/models/reports/reports';
import { IBusinessView } from 'app/models/business/business';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class ReportsService {
  public api: string = environment.privateApi + 'Reports/';

  private http = inject(HttpClient);

  // Business Report
  getBusinessReportData(county: string, sortOrder: string): Observable<IBusinessView[]> {
    return this.http.get<IBusinessView[]>(this.api + 'getBusinessReportData/' + county + '/' + sortOrder);
  }

  // Complaint Statuses
  getComplaintStatusData(search: IComplaintSearchViewModel): Observable<IAdministrativeComplaintView[]> {
    return this.http.post<IAdministrativeComplaintView[]>(this.api + 'getComplaintStatusData', search);
  }

  getComplaintStatusList(): Observable<IReportSelectItems[]> {
    return this.http.get<IReportSelectItems[]>(this.api + 'getComplaintStatusList');
  }

  // Complaint Violations
  getComplaintViolationsList(): Observable<IReportSelectItems[]> {
    return this.http.get<IReportSelectItems[]>(this.api + 'getComplaintViolationsList');
  }

  getComplaintViolationsData(search: IComplaintSearchViewModel):
    Observable<IAdministrativeComplaintView[]> {
    return this.http.post<IAdministrativeComplaintView[]>(this.api + 'getComplaintViolationsData', search);
  }

  // Exempt Businesses
  getExemptBusinessesData(): Observable<IBusinessView[]> {
    return this.http.get<IBusinessView[]>(this.api + 'getExemptBusinessesData');
  }
  
  // Enclosed Area Report
  getEnclosedAreaReportData(): Observable<IEnclosedAreaReportView[]> {
    return this.http.get<IEnclosedAreaReportView[]>(this.api + 'getEnclosedAreaReportData');
  }
  

  // Citation Report
  getCitationReportData(filter: string): Observable<IBusinessCitationView[]> {
    return this.http.get<IBusinessCitationView[]>(this.api + 'getCitationReportData/' + filter);
  }

}
